export const MERGE_ENTITIES = 'MERGE_ENTITIES_WC';
